import { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import CommonInput from "../../components/input/CommonInput";
import SignAlert from "../../components/alert/SignAlert";

// data
import { NoSignUpAlert } from "../../data/alertData";
import { requestResetPassword } from "../../services/api/user";

function ForgotPWPage() {
    const navigate = useNavigate();

    const [input, setInput] = useState({
        email: ""
    });

    const [ noSignUpAlert, setNoSignUpAlert] = useState(false);

    const handleInput = (value, type) => {
        setInput({
            ...input,
            [type]: value
        })
    }

    const handleSubmit = async (e)=> {
        e.preventDefault();

        try{
            const res = await requestResetPassword(input.email.trim());

            if(res.data.result==="Success"){
                navigate("/forgot-password/check-email", {state: input.email.trim()})
            }else {
                setNoSignUpAlert(true);
            }
            
        }catch(err){
            console.error(err);
        }
    }

    return (
        <form className="ForgotPWPage" onSubmit={handleSubmit} noValidate>
            <div className="EmailInput">
                <CommonInput
                    type="email"
                    legend="Email"
                    placeholder="Enter your email."
                    handleInput={handleInput}
                    input={input}
                /> 
            </div>
            <button
                type="submit"
                className="ContinueButton"
                disabled={!input.email}
            >
                Continue
            </button>
            {noSignUpAlert && <SignAlert data={NoSignUpAlert} setAlert={setNoSignUpAlert} />}
        </form>
    );
}

export default ForgotPWPage;